var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"abstract-4",attrs:{"src":require('@/assets/abstract4.png'),"height":"90%","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }